import { render } from "./NewBedTypeForm.vue?vue&type=template&id=0bd540a0&scoped=true"
import script from "./NewBedTypeForm.vue?vue&type=script&lang=js"
export * from "./NewBedTypeForm.vue?vue&type=script&lang=js"

import "./NewBedTypeForm.vue?vue&type=style&index=0&id=0bd540a0&lang=css&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0bd540a0"]])

export default __exports__